/**
 * Format numbers in Indian number system
 * Cr (Crore) = 10,000,000
 * L (Lakh) = 100,000
 * K (Thousand) = 1,000
 */

export const formatAmount = (num) => {
  if (!num || isNaN(num)) return '0';
  
  const number = parseFloat(num);
  
  // Negative numbers
  const isNegative = number < 0;
  const absNum = Math.abs(number);
  
  let formatted = '';
  
  if (absNum >= 10000000) {
    // Crore (10 million+)
    formatted = (absNum / 10000000).toFixed(2) + ' Cr';
  } else if (absNum >= 100000) {
    // Lakh (100 thousand+)
    formatted = (absNum / 100000).toFixed(2) + ' L';
  } else if (absNum >= 1000) {
    // Thousand
    formatted = (absNum / 1000).toFixed(2) + ' K';
  } else {
    // Less than 1000
    formatted = absNum.toFixed(2);
  }
  
  // Remove trailing zeros after decimal
  formatted = formatted.replace(/\.00/, '');
  
  return isNegative ? '-' + formatted : formatted;
};

/**
 * Format currency with Indian format
 */
export const formatCurrency = (num, currency = '₹') => {
  if (!num || isNaN(num)) return `${currency}0`;
  return `${currency}${formatAmount(num)}`;
};

/**
 * Format count/quantity (no decimal for counts)
 */
export const formatCount = (num) => {
  if (!num || isNaN(num)) return '0';
  
  const number = parseFloat(num);
  const absNum = Math.abs(number);
  
  let formatted = '';
  
  if (absNum >= 10000000) {
    formatted = (absNum / 10000000).toFixed(1) + ' Cr';
  } else if (absNum >= 100000) {
    formatted = (absNum / 100000).toFixed(1) + ' L';
  } else if (absNum >= 1000) {
    formatted = (absNum / 1000).toFixed(1) + ' K';
  } else {
    formatted = absNum.toString();
  }
  
  // Remove .0
  formatted = formatted.replace(/\.0\s/, ' ');
  
  return number < 0 ? '-' + formatted : formatted;
};

export default formatAmount;
